import React from "react";
import { motion } from "framer-motion";
import { Sparkles, ArrowLeft } from "lucide-react";

export default function Hero({ settings, content }) {
  const tagline = settings?.hero_tagline || "على المسرح تبدأ حكايتك";

  const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <section
      data-testid="hero-section"
      className="relative pt-32 pb-24 md:pt-40 md:pb-32 overflow-hidden stage-spotlight grain-overlay"
    >
      <div className="curtain-side-left hidden md:block" />
      <div className="curtain-side-right hidden md:block" />

      {/* Faint stage image */}
      <div
        aria-hidden
        className="absolute inset-0 opacity-25 mix-blend-luminosity"
        style={{
          backgroundImage:
            "url('/hero-bg.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          filter: "blur(1px)",
        }}
      />
      <div className="absolute inset-0 curtain-fade" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-8 text-center z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, ease: "easeOut" }}
          className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-[#F0E8DB]/40 bg-[#1A0F0E]/60 backdrop-blur-sm text-[#F0E8DB] text-xs sm:text-sm mb-6"
        >
          <Sparkles size={14} />
          <span className="font-serif-en tracking-widest">THE STAGE AWAITS</span>
        </motion.div>

        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.1, delay: 0.15 }}
          className="text-4xl sm:text-5xl lg:text-7xl font-bold text-[#F0E8DB] leading-tight mb-4"
          style={{ fontFamily: "'IBM Plex Sans Arabic', sans-serif" }}
        >
          <span className="tagline-shimmer">{tagline}</span>
        </motion.h1>

        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1.2, delay: 0.4 }}
          className="text-base sm:text-lg text-[#C5B8A8] max-w-2xl mx-auto mb-10 leading-relaxed"
        >
          بين كاتب، ومخرج، وممثل، ومنظّم تتشكّل حكايتنا. هنا نكتشف الطاقات ونحوّل الشغف إلى عرض لا يُنسى.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.6 }}
          className="flex flex-wrap gap-4 justify-center"
        >
          <button
            data-testid="hero-join-cta"
            onClick={() => scrollTo("contact")}
            className="btn-gold rounded-full px-8 py-3 flex items-center gap-2"
          >
            انضم إلى النادي
            <ArrowLeft size={16} />
          </button>
          <button
            data-testid="hero-explore-plays-cta"
            onClick={() => scrollTo("team")}
            className="btn-ghost rounded-full px-8 py-3"
          >
            تعرّف على اللجان
          </button>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1, duration: 1 }}
          className="mt-16 text-[#BFB3A0] text-sm sm:text-base"
          data-testid="hero-quote"
        >
          «{content.hero_quote}» — <span className="text-[#F0E8DB]">{content.hero_quote_author}</span>
        </motion.div>
      </div>
    </section>
  );
}
